var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.loggedIn),expression:"loggedIn"}],staticStyle:{"height":"100%"}},[_c('ClientAdminToolBar'),_c('client-admin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }